import { render } from "./FAQAdminComponent.vue?vue&type=template&id=42baeedf&scoped=true"
import script from "./FAQAdminComponent.vue?vue&type=script&lang=js"
export * from "./FAQAdminComponent.vue?vue&type=script&lang=js"

import "./FAQAdminComponent.vue?vue&type=style&index=0&id=42baeedf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42baeedf"

export default script